import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../../shared/services/local-storage.service';

export const authGuard: CanActivateFn = async (route) => {
  const localStorage = inject(LocalStorageService);
  const router = inject(Router);

  const hasAccessToken = !!localStorage.getAccessToken();
  if (!hasAccessToken) {
    return router.parseUrl('/login');
  }

  return true;
};
